<template>
    <div>
      <Navbar />
  
      <main>
  
        <!-- ── Hero ── -->
        <section class="page-hero">
          <div class="page-hero-overlay"></div>
          <div class="page-container">
            <div class="page-hero-content">
              <h1 class="page-hero-title">Our Blog Posts</h1>
              <nav class="breadcrumb-nav" aria-label="Breadcrumb">
                <router-link to="/home" class="breadcrumb-link">Home</router-link>
                <span class="breadcrumb-sep">/</span>
                <span class="breadcrumb-current">Our Blog Posts</span>
              </nav>
            </div>
          </div>
        </section>
  
        <!-- ── Blog Listing ── -->
        <section class="section-pad">
          <div class="page-container">
  
            <div class="section-header">
              <span class="section-badge">Latest Insights</span>
              <h2 class="section-title">Business Automation, Finance & Inventory Knowledge Hub</h2>
              <p class="section-body">
                Discover product updates, accounting strategies, inventory intelligence,
                AI finance trends and practical growth resources for modern businesses.
              </p>
            </div>
  
            <div v-if="loading" class="loading-state">
              <div class="spinner-border text-primary" role="status" style="width:2.5rem;height:2.5rem;"></div>
            </div>
  
            <div v-else class="blog-grid">
              <div v-for="blog in details" :key="blog.id" class="blog-card">
                <router-link :to="'/blog/' + blog.slug" class="blog-image-wrap">
                  <img :src="url.hostName + 'images/blog/' + blog.image" :alt="blog.title" />
                </router-link>
  
                <div class="blog-card-body">
                  <span class="blog-category">{{ blog.category ? blog.category.name : 'General' }}</span>
  
                  <h3 class="blog-title">
                    <router-link :to="'/blog/' + blog.slug">
                      {{ blog.title }}
                    </router-link>
                  </h3>
  
                  <p class="blog-excerpt">
                    {{ strip(blog.description).substring(0, 115) + '...' }}
                  </p>
  
                  <div class="blog-meta">
                    <span><font-awesome-icon icon="calendar-alt" class="meta-icon" /> {{ formatDate(blog.created_at) }}</span>
                    <span><font-awesome-icon icon="comments" class="meta-icon" /> {{ blog.comments.length }}</span>
                  </div>
  
                  <router-link :to="'/blog/' + blog.slug" class="read-more-link">
                    Read More <font-awesome-icon icon="arrow-right" class="ms-2" />
                  </router-link>
                </div>
              </div>
            </div>
  
            <pagination
              :pagination="pagination"
              @prev="pageData(pagination.prevPageUrl)"
              @next="pageData(pagination.nextPageUrl)"
              v-if="details.length > 0"
            ></pagination>
  
          </div>
        </section>
  
        <!-- ── CTA ── -->
        <section class="cta-band">
          <div class="page-container cta-band-inner">
            <div>
              <h2 class="cta-title">Want more Mapiibs updates?</h2>
              <p class="cta-sub">
                Explore how automation, AI bookkeeping and inventory intelligence can scale your business faster.
              </p>
            </div>
            <router-link to="/auth/register" class="btn-white-lg">
              Get Started <font-awesome-icon icon="arrow-right" class="ms-2" />
            </router-link>
          </div>
        </section>
  
      </main>
  
      <Footer />
    </div>
  </template>
  
  <script>
  import Navbar from "../components/Navbar";
  import Footer from "../components/footer";
  import axios from "axios";
  import moment from "moment-timezone";
  import hostName from "../main";
  
  export default {
    name: "BlogPage",
  
    components: {
      Navbar,
      Footer,
    },
  
    data() {
      return {
        details: [],
        loading: true,
        url: hostName,
        pagination: {
          lastPage: "",
          currentPage: "",
          total: "",
          lastPageUrl: "",
          nextPageUrl: "",
          prevPageUrl: "",
          from: "",
          to: "",
        },
      };
    },
  
    mounted() {
      this.scrollTop();
      this.pageData();
    },
  
    methods: {
      scrollTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      },
  
      async pageData(pageUrl = "/admin/active-blog") {
        await axios.get(pageUrl).then((response) => {
          this.details = response.data.data.data;
          this.configPagination(response.data.data);
          this.loading = false;
        });
      },
  
      configPagination(data) {
        this.pagination.lastPage = data.last_page;
        this.pagination.currentPage = data.current_page;
        this.pagination.total = data.total;
        this.pagination.lastPageUrl = data.last_page_url;
        this.pagination.nextPageUrl = data.next_page_url;
        this.pagination.prevPageUrl = data.prev_page_url;
        this.pagination.from = data.from;
        this.pagination.to = data.to;
      },
  
      formatDate(date) {
        return moment(date).format("MMM DD, YYYY");
      },
  
      strip(html) {
        let doc = new DOMParser().parseFromString(html, "text/html");
        return doc.body.textContent || "";
      },
    },
  
    watch: {
      query() {
        this.pageData();
      },
    },
  };
  </script>
  
  <style scoped>
  .page-container { max-width:1160px; margin:0 auto; padding:0 24px; }
  .section-pad { padding:80px 0; }
  .ms-2 { margin-left:8px; }
  
  .section-header { text-align:center; max-width:760px; margin:0 auto 52px; }
  .section-badge {
    display:inline-block;
    background:rgba(0,74,173,.1);
    color:#004AAD;
    border:1px solid rgba(0,74,173,.2);
    border-radius:20px;
    padding:4px 14px;
    font-size:12px;
    font-weight:700;
    text-transform:uppercase;
    letter-spacing:.08em;
    margin-bottom:14px;
  }
  .section-title {
    font-size:clamp(24px,3.5vw,34px);
    font-weight:700;
    color:#1a2b45;
    margin:0 0 14px;
    line-height:1.3;
  }
  .section-body {
    font-size:15px;
    color:#6b7a99;
    line-height:1.7;
    margin:0;
  }
  
  .page-hero {
    position: relative;
    background: linear-gradient(135deg, #051B35 0%, #004AAD 100%);
    padding: 100px 0 64px;
    overflow: hidden;
  }
  .page-hero::before {
    content:'';
    position:absolute;
    inset:0;
    background:url('/static/img/banner-bg-5.jpg') center/cover no-repeat;
    opacity:.08;
  }
  .page-hero-overlay {
    position:absolute;
    inset:0;
    background:linear-gradient(135deg, rgba(5,27,53,.92) 0%, rgba(0,74,173,.75) 100%);
  }
  .page-hero-content { position:relative; z-index:1; text-align:center; }
  .page-hero-title {
    font-size:clamp(32px,6vw,52px);
    font-weight:800;
    color:#fff;
    margin:0 0 18px;
  }
  
  .breadcrumb-nav { display:inline-flex; align-items:center; gap:8px; font-size:14px; }
  .breadcrumb-link { color:rgba(255,255,255,.7); text-decoration:none; }
  .breadcrumb-link:hover { color:#fff; }
  .breadcrumb-sep { color:rgba(255,255,255,.3); }
  .breadcrumb-current { color:rgba(255,255,255,.55); }
  
  .loading-state {
    display:flex;
    justify-content:center;
    padding:50px 0;
  }
  
  .blog-grid {
    display:grid;
    grid-template-columns:repeat(3,1fr);
    gap:24px;
    margin-bottom:40px;
  }
  
  .blog-card {
    background:#fff;
    border:1px solid #e4eaf2;
    border-radius:16px;
    overflow:hidden;
    transition:all .2s ease;
  }
  .blog-card:hover {
    transform:translateY(-4px);
    box-shadow:0 12px 30px rgba(0,0,0,.08);
  }
  
  .blog-image-wrap {
    display:block;
    height:230px;
    overflow:hidden;
  }
  .blog-image-wrap img {
    width:100%;
    height:100%;
    object-fit:cover;
    transition:transform .3s ease;
  }
  .blog-card:hover img {
    transform:scale(1.05);
  }
  
  .blog-card-body {
    padding:22px;
  }
  
  .blog-category {
    display:inline-block;
    font-size:11px;
    font-weight:700;
    color:#004AAD;
    text-transform:uppercase;
    letter-spacing:.08em;
    margin-bottom:12px;
  }
  
  .blog-title {
    font-size:18px;
    font-weight:700;
    line-height:1.45;
    margin:0 0 12px;
  }
  .blog-title a {
    color:#1a2b45;
    text-decoration:none;
  }
  
  .blog-excerpt {
    font-size:14px;
    color:#6b7a99;
    line-height:1.7;
    margin:0 0 18px;
  }
  
  .blog-meta {
    display:flex;
    gap:18px;
    font-size:13px;
    color:#7b879d;
    border-top:1px solid #edf1f6;
    padding-top:14px;
    margin-bottom:16px;
  }
  .meta-icon {
    margin-right:5px;
  }
  
  .read-more-link {
    display:inline-flex;
    align-items:center;
    text-decoration:none;
    font-size:13px;
    font-weight:700;
    color:#004AAD;
  }
  
  .cta-band {
    background:linear-gradient(135deg,#004AAD,#0059d6);
    padding:56px 0;
  }
  .cta-band-inner {
    display:flex;
    justify-content:space-between;
    align-items:center;
    gap:24px;
    flex-wrap:wrap;
  }
  .cta-title {
    font-size:26px;
    font-weight:700;
    color:#fff;
    margin:0 0 8px;
  }
  .cta-sub {
    font-size:15px;
    color:rgba(255,255,255,.75);
    margin:0;
  }
  .btn-white-lg {
    display:inline-flex;
    align-items:center;
    text-decoration:none;
    background:#fff;
    color:#004AAD;
    padding:12px 24px;
    border-radius:10px;
    font-size:14px;
    font-weight:700;
  }
  
  @media (max-width:992px){
    .blog-grid { grid-template-columns:repeat(2,1fr); }
  }
  @media (max-width:768px){
    .section-pad { padding:56px 0; }
    .blog-grid { grid-template-columns:1fr; }
    .page-hero { padding:80px 0 52px; }
  }
  </style>